import { spiritIslandChapters } from './content';
export const spiritIslandFaq = spiritIslandChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('FAQ'));
